import type { Core } from 'cytoscape';
import type { OverlayCanvas } from './overlay-canvas';
import type { MaporiumGridOptions } from './options';

/** Screen px below which grid lines merge, so the spacing doubles until legible. */
const MIN_RENDERED_SPACING = 12;

export function drawGrid(cy: Core, overlay: OverlayCanvas, options: MaporiumGridOptions): void {
  overlay.sync();
  overlay.clear();

  if (!(options.gridSpacing > 0)) {
    return;
  }

  let spacing = options.gridSpacing * cy.zoom();
  while (spacing > 0 && spacing < MIN_RENDERED_SPACING) {
    spacing *= 2;
  }

  const pan = options.panGrid ? cy.pan() : { x: 0, y: 0 };
  const { ctx, width, height } = overlay;
  const ratio = window.devicePixelRatio || 1;
  const halfPixel = Math.round(options.lineWidth * ratio) % 2 === 1 ? 0.5 / ratio : 0;
  const align = (value: number) => Math.round(value * ratio) / ratio + halfPixel;

  ctx.save();
  ctx.beginPath();
  ctx.strokeStyle = options.gridColor;
  ctx.lineWidth = options.lineWidth;

  for (let x = (((pan.x % spacing) + spacing) % spacing) - spacing; x < width; x += spacing) {
    const px = align(x);
    ctx.moveTo(px, 0);
    ctx.lineTo(px, height);
  }

  for (let y = (((pan.y % spacing) + spacing) % spacing) - spacing; y < height; y += spacing) {
    const py = align(y);
    ctx.moveTo(0, py);
    ctx.lineTo(width, py);
  }

  ctx.stroke();
  ctx.restore();
}
